// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */

export interface IUserInChatListSchema {
  /** Название компании **/
  agencyName?: string;
  /**
   *
   *     Тип пользователя. Тут не совпадение, так как указано что как-будто типы только агентов, а на самом деле
   *     могут быть все типы пользователей.
   *
   */
  agentAccountType?: EAgentAccountType;
  /** Сссылка на аватарку **/
  agentAvatarUrl?: string;
  /** Имя наемного агента **/
  agentName?: string;
  /** Роль пользователя в чате, в котором он передан **/
  chatRole: EChatRole;
  /** Имя **/
  firstName?: string;
  /** Пользователь имеет опубликованный профиль в каталоге специалистов **/
  hasPublicProfile: boolean;
  /** Фамилия **/
  lastName?: string;
  /** Имя **/
  name: string;
  /** Ссылка на изображение, которая должна использоваться вместо имени пользователя на клиентах **/
  nameReplacementImageUrl?: string;
  /** Телефон **/
  phone?: string;
  /** Абсолютный URL на публичный профиль агента **/
  urlToAgentPublicProfile?: string;
  /** ID пользователя **/
  userId: number;
}
export enum EAgentAccountType {
  /** Специалист **/
  'Agency' = 'agency',
  /** Застройщик **/
  'Developer' = 'developer',
  /** Собственник **/
  'Homeowner' = 'homeowner',
  /** Управляющая компания **/
  'Management_company' = 'management_company',
  /** Отдел аренды **/
  'Rent_department' = 'rent_department',
  /** Поискун **/
  'Searcher' = 'searcher',
  /** Риэлтор **/
  'Specialist' = 'specialist',
  /** Системные сообщения от администрации ЦИАН-а **/
  'System' = 'system',
}
export enum EChatRole {
  /** Другие собеседники (участники) чата, помимо инициатора (initiator) и оппонента (opponent) **/
  'Companion' = 'companion',
  /** Инициатор чата, то есть этот пользователь первым написал сообщение **/
  'Initiator' = 'initiator',
  /** Собеседник, который является мастером для оппонента, который является его суб-агентом **/
  'Master' = 'master',
  /** Тот кому написал инициатор, то есть этот пользователь получил первое сообщение от инициатора **/
  'Opponent' = 'opponent',
}
